import { withTheme } from "@mui/styles";
import JobPageContainer from "./JobPageContainer";
import JobPageStore from "./JobPageStore";

export default JobPageStore(withTheme(JobPageContainer));